import React from 'react';
import TemplateAction from '~/glm/components/import-spreadsheet/template-action';
import { H4, Body1 } from '@xo-union/tk-ui-typography';
import styles from './use-template-section.scss';

const UseTemplateSection = () => (
  <>
    <H4 className={styles.useTemplate}>1. Choose your template</H4>
    <Body1 className={styles.useTemplateSubHeader}>
      Start by drafting your list using our easy-to-use spreadsheet templates.
    </Body1>
    <div className={styles.actionContainer}>
      <TemplateAction type="download" />
      <span className={styles.or}>or</span>
      <TemplateAction type="linkout" />
    </div>
  </>
);

export default UseTemplateSection;
